// react documenation used: https://react.dev/learn
// axios documentation used: https://axios-http.com/docs/intro
import React, { useState, useEffect } from "react";
import styles from "./repoDetails.module.css";
import axios from "axios";

function RepositoryDetailsPopup({ repo, onClose }) {
  const [category, setCategory] = useState("");
  const [accessLevel, setAccessLevel] = useState("");
  const apiUrl = process.env.REACT_APP_API_URL;
  const [isRepoShared, setIsRepoShared] = useState(null);

  useEffect(() => {
    const checkRepoShared = async () => {
      try {
        const response = await axios.get(
          `${apiUrl}/api/requests/checkRepositoryExists/${repo.id}`
        );
        setIsRepoShared(response.data.exists);
      } catch (error) {
        console.error("Error checking repository existence:", error);
        setIsRepoShared(false);
      }
    };

    if (repo) {
      checkRepoShared();
    }
  }, [repo, apiUrl]);

  const shareRepository = async (repository, category, accessLevel) => {
    const token = localStorage.token;
    const jwtToken = encodeURIComponent(token);

    try {
      await axios.post(`${apiUrl}/api/requests/shareRepository`, {
        id: repository.id,
        name: repository.name,
        description: repository.description,
        url: repository.html_url,
        owner: repository.owner,
        category: category,
        avatar: repository.avatar,
        language: repository.language,
        accessLevel: accessLevel,
        token: jwtToken,
      });
      alert("Repository shared successfully");
      onClose();
    } catch (error) {
      console.error("Failed to share the repository:", error);
      alert("Failed to share the repository");
    }
  };

  const deleteRepository = async (repositoryId) => {
    try {
      await axios.delete(
        `${apiUrl}/api/requests/deleteRepository/${repositoryId}`
      );
      alert("Repository removed successfully");
      onClose();
    } catch (error) {
      console.error("Failed to remove the repository:", error);
      alert("Failed to remove the repository");
    }
  };

  return (
    <div className={styles.popupOverlay}>
      <div
        className={styles.popupContent}
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <h2>{repo.name}</h2>
        <p>Description: {repo.description}</p>
        <p>
          URL:{" "}
          <a href={repo.html_url} target="_blank" rel="noopener noreferrer">
            {repo.html_url}
          </a>
        </p>
        <p>Languages: {repo.language}</p>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <p>Owner: </p>
          {repo.avatar && (
            <img
              src={repo.avatar}
              alt={`${repo.owner}'s avatar`}
              style={{ width: "50px", height: "50px", borderRadius: "50%" }}
            />
          )}
          <p>{repo.owner}</p>
        </div>
        {isRepoShared === false && (
          <>
            <select
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              className={styles.dropdown}
            >
              <option value="">Select a Category</option>
              <option value="APIs">APIs</option>
              <option value="Interfaces">Interfaces</option>
              <option value="Frontend">Frontend</option>
              <option value="Backend">Backend</option>
              <option value="Webpages">Webpages</option>
              <option value="Application">Application</option>
              <option value="Mobile Apps">Mobile Apps</option>
              <option value="Databases">Databases</option>
              <option value="Embedded Systems">Embedded Systems</option>
              <option value="Cloud">Cloud</option>
            </select>
            <select
              value={accessLevel}
              onChange={(e) => setAccessLevel(e.target.value)}
              className={styles.dropdown}
            >
              <option value="">Select Access Level</option>
              <option value="confidential">Confidential</option>
              <option value="non-confidential">Non-Confidential</option>
            </select>
            <button
              onClick={() => shareRepository(repo, category, accessLevel)}
            >
              Share Repository
            </button>
          </>
        )}

        {isRepoShared === true && (
          <button
            onClick={() => deleteRepository(repo.id)}
            className={styles.removeButton}
          >
            Remove Shared Repository
          </button>
        )}

        <button onClick={onClose}>Close</button>
      </div>
    </div>
  );
}

export default RepositoryDetailsPopup;
